// PRODUCT PAGE
const observer = new MutationObserver((mutations, obs) => {
    // Hide default slide only if Supadu interior images exist
    const folioImages = document.querySelector('.folio-images');
    if (!folioImages) return;

    const thumbnailCarousel = document.querySelector('[id^="Thumbnail-Carousel-template"]');
    if (!thumbnailCarousel) return;

    thumbnailCarousel.style.display = 'none';

    obs.disconnect();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});